import urgiDoctorLogo from "../assets/logo/urgi-doctor-logo.png";
import sideImage_1 from "../assets/onboarding/side-contents/sideImage_1.svg";
import sideImage_2 from "../assets/onboarding/side-contents/sideImage_2.png";
import oulinedLogo from "../assets/logo/oulined-logo.svg";
import swipeLogo from "../assets/logo/swipe-logo.png";
import gettingStarted from "../assets/onboarding/gettingStarted.png";
import profileCard from "../assets/onboarding/profileCard.png";
import profileComplete from "../assets/onboarding/profileComplete.png";
import location from "../assets/onboarding/location.png";
import QRCode from "../assets/onboarding/QrCode.jpeg";

import homeScene_1 from "../assets/onboarding/homeScene_1.png";
import homeScene_2 from "../assets/onboarding/homeScene_2.png";
import homeScene_3 from "../assets/onboarding/homeScene_3.png";
import homeScene_4 from "../assets/onboarding/homeScene_4.png";
import homeScene_5 from "../assets/onboarding/homeScene_5.png";
import homeScene_6 from "../assets/onboarding/homeScene_6.png";
import homeScene_7 from "../assets/onboarding/homeScene_7.png";

import spikes from "../assets/images/spikes.svg";
import spikes_2 from "../assets/images/spikes_2.svg";
import spikes_3 from "../assets/images/spikes_3.svg";
import spikes_4 from "../assets/images/spikes_4.svg";
import spikes_5 from "../assets/images/spikes_5.svg";
import spikes_6 from "../assets/images/spikes_6.svg";
import spikes_7 from "../assets/images/spikes_7.svg";

// SIDE-MENU
import urgiLogoFaint from "../assets/dashboard/sideMenu/urgiDoctorLogoFaintPng.png";

// TOP-BAR
import logOutLogo from "../assets/dashboard/logoutLogoPng.png";
import TopBarProfileImg from "../assets/dashboard/PCDProfileImg.png";

// NOTIFICATIONS
import PCPNotificationLogo from "../assets/dashboard/notifications/PCPNotificationLogo.png";

//APPOINTMENTS
import PCDProfileImg from "../assets/dashboard/PCDProfileImg.png";
import acceptAppointment from "../assets/dashboard/appointment/accept_appointment.png";
import leftArrow from "../assets/dashboard/appointment/left-arrow.svg";
import rightArrow from "../assets/dashboard/appointment/right-arrow.svg";
import calendar from "../assets/dashboard/patient_profile_calendar.png";
import notificationBell from "../assets/dashboard/appointment/visit_now.gif";

import defaultPic from "../assets/onboarding/default_pic.png";
import noDataFound from "../assets/dashboard/noDataFound.svg";

import allergies from "../assets/dashboard/patientProfile/allergies.png";
import medical_condition from "../assets/dashboard/patientProfile/medical_condition.png";
import previous_surgery from "../assets/dashboard/patientProfile/previous_surgery.png";
import pharmacy from "../assets/dashboard/patientProfile/pharmacy.png";
import medications from "../assets/dashboard/patientProfile/medications.png";
import family_medical_history from "../assets/dashboard/patientProfile/family_medical_history.png";
import doc_icon from "../assets/dashboard/patientProfile/doc_icon.png";
import under_review_gif from "../assets/onboarding/under_review.gif";

import amex from "../assets/cardImages/amex.svg";
import defaultcard from "../assets/cardImages/defaultcard.svg";
import diners from "../assets/cardImages/diners.svg";
import jcb from "../assets/cardImages/jcb.svg";
import mastercard from "../assets/cardImages/mastercard.svg";
import unionpay from "../assets/cardImages/unionpay.svg";
import visa from "../assets/cardImages/visa.svg";

//social share
import copy_icon from "../assets/images/copy-icon.svg";
import linkedin from "../assets/images/linkedin.svg";
import facebook from "../assets/images/facebook.svg";
import twitter from "../assets/images/twitter.svg";
import notificationSound from "../assets/audio/notificationSound.mp3";
import ringingSound from "../assets/audio/Ring-basic.mp3";

import Powered_by_Stripe from "../assets/onboarding/Powered_by_Stripe.png";

import Card_IMAGE from "../assets/cardImages/credit_card.png";
import Bank_IMAGE from "../assets/cardImages/bank.png";

import Appointment_Reminder from "../assets/dashboard/appointment/appointment_reminder.png";

import PageNotFound from "../assets/images/404_notfound.png";

export const URGI_DOCTOR_LOGO = urgiDoctorLogo;
export const SIDE_IMAGE_1 = sideImage_1;
export const SIDE_IMAGE_2 = sideImage_2;
export const OUTLINED_LOGO = oulinedLogo;
export const SWIPE_LOGO = swipeLogo;

export const HOME_SCENE_1 = homeScene_1;
export const HOME_SCENE_2 = homeScene_2;
export const HOME_SCENE_3 = homeScene_3;
export const HOME_SCENE_4 = homeScene_4;
export const HOME_SCENE_5 = homeScene_5;
export const HOME_SCENE_6 = homeScene_6;
export const HOME_SCENE_7 = homeScene_7;

export const GETTING_STARTED = gettingStarted;
export const PROFILE_CARD = profileCard;
export const PROFILE_COMPLETE = profileComplete;
export const LOCATION = location;

export const SPIKES = spikes;
export const SPIKES_2 = spikes_2;
export const SPIKES_3 = spikes_3;
export const SPIKES_4 = spikes_4;
export const SPIKES_5 = spikes_5;
export const SPIKES_6 = spikes_6;
export const SPIKES_7 = spikes_7;

export const URGI_DOCTOR_LOGO_FAINT = urgiLogoFaint;

export const LOG_OUT_LOGO = logOutLogo;
export const TOP_BAR_PROFILE_IMAGE = TopBarProfileImg;

export const PCP_NOTIFICATION_LOGO = PCPNotificationLogo;

export const DOCTOR_PROFILE_IMAGE = PCDProfileImg;
export const ACCEPT_APPOINTMENT = acceptAppointment;
export const LEFT_ARROW = leftArrow;
export const RIGHT_ARROW = rightArrow;
export const CALENDAR = calendar;
export const NOTIFICATION_BELL = notificationBell;

export const DEFAULT_PIC = defaultPic;

export const NO_DATA_FOUND = noDataFound;

export const PATIENT_ALLERGIES = allergies;
export const PATIENT_MEDICAL_CONDITION = medical_condition;
export const PATIENT_PREVIOUS_SURGERY = previous_surgery;
export const PATIENT_PHARMACY = pharmacy;
export const PATIENT_MEDICATIONS = medications;
export const PATIENT_FAMILIY_MEDICAL_HISTORY = family_medical_history;
export const DOC_ICON = doc_icon;

export const QR_CODE = QRCode;

export const PAGE_NOT_FOUND = PageNotFound;

export const CARDS_IMAGES = {
  amex,
  defaultcard,
  diners,
  jcb,
  mastercard,
  unionpay,
  visa,
};
export const TWITTER = twitter;
export const FACEBOOK = facebook;
export const COPY_ICON = copy_icon;
export const LINKEDIN = linkedin;

//sound
export const NOTIFICATION_SOUND = notificationSound;
export const PHONE_RING_SOUND = ringingSound;
export const UNDER_REVIEW_GIF = under_review_gif;

export const POWERED_BY_STRIPE = Powered_by_Stripe;

export const CARD_IMAGE = Card_IMAGE;
export const BANK_IMAGE = Bank_IMAGE;

export const APPOINTMENT_REMINDER = Appointment_Reminder;
